module.exports = __webpack_public_path__ + "img/2.5896de76.png";